import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getAuthState = (state: GlobalState) => state[KEY];

const selectToken = createSelector(getAuthState, (auth) => auth.token);

const selectAuthenticating = createSelector(getAuthState, (auth) => auth.authenticating);

const selectError = createSelector(getAuthState, (auth) => auth.error);

const selectAdmin = createSelector(getAuthState, (auth) => auth.admin);

const selectIsAuthenticated = createSelector(selectToken, (token) => !!token);

const selectAction = createSelector(getAuthState, (auth) => auth.action);

const selectActionPending = createSelector(selectAction, (action) => action.pending);

const selectActionSuccessful = createSelector(selectAction, (action) => action.successful);

const selectActionError = createSelector(selectAction, (action) => action.error);

export const selectors = {
  selectToken,
  selectAuthenticating,
  selectError,
  selectAdmin,
  selectIsAuthenticated,
  selectActionPending,
  selectActionSuccessful,
  selectActionError
};
